import React from 'react';
import { Link } from 'react-router-dom';

const FooterNav = ({ menu }) => (
    <nav className="footer-nav">
        <ul>
            {menu.map((menuItem) => {
                return (
                    <li key={menuItem.link}>
                        { 
                            menuItem.isRouter ?
                            <Link to={menuItem.link}>{menuItem.label}</Link> :
                            <a href={menuItem.link} target="_blank">{menuItem.label}</a>
                        }
                    </li>
                )
            })}
        </ul>
    </nav>
);

export default FooterNav;


// WEBPACK FOOTER //
// ./src/components/Footer/FooterNav.js